// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_time_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `invalid date`
};

const de_widget_time_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `ungültiges Datum`
};

const es_widget_time_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `fecha inválida`
};

const fr_widget_time_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `date invalide`
};

const fi_widget_time_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `virheellinen päivämäärä`
};

const hi_widget_time_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `अवैध तारीख`
};

const ja_widget_time_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `無効な日付`
};

const nl_widget_time_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `ongeldige datum`
};

const pt_widget_time_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `data inválida`
};

const ro_widget_time_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `dată invalidă`
};

const th_widget_time_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `วันที่ไม่ถูกต้อง`
};

const ur_widget_time_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `غلط تاریخ`
};

const zh_hant1_widget_time_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `無效日期`
};

const da_widget_time_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `ugyldig dato`
};

const it_widget_time_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `data non valida`
};

const vn_widget_time_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `ngày không hợp lệ`
};

const ko_widget_time_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `유효하지 않은 날짜`
};

const tr_widget_time_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `geçersiz tarih`
};

const lv_widget_time_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `nederīgs datums`
};

const ar_widget_time_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `تاريخ غير صحيح`
};

const bs_widget_time_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `neważeći datum`
};

const sl_widget_time_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `neveljaven datum`
};

const id_widget_time_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `tanggal tidak valid`
};

const sv_widget_time_invalid_date = /** @type {(inputs: {}) => string} */ () => {
	return `ogiltigt datum`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_time_invalid_date = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_time_invalid_date(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_time_invalid_date", locale)
	if (locale === "en") return en_widget_time_invalid_date(inputs)
	if (locale === "de") return de_widget_time_invalid_date(inputs)
	if (locale === "es") return es_widget_time_invalid_date(inputs)
	if (locale === "fr") return fr_widget_time_invalid_date(inputs)
	if (locale === "fi") return fi_widget_time_invalid_date(inputs)
	if (locale === "hi") return hi_widget_time_invalid_date(inputs)
	if (locale === "ja") return ja_widget_time_invalid_date(inputs)
	if (locale === "nl") return nl_widget_time_invalid_date(inputs)
	if (locale === "pt") return pt_widget_time_invalid_date(inputs)
	if (locale === "ro") return ro_widget_time_invalid_date(inputs)
	if (locale === "th") return th_widget_time_invalid_date(inputs)
	if (locale === "ur") return ur_widget_time_invalid_date(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_time_invalid_date(inputs)
	if (locale === "da") return da_widget_time_invalid_date(inputs)
	if (locale === "it") return it_widget_time_invalid_date(inputs)
	if (locale === "vn") return vn_widget_time_invalid_date(inputs)
	if (locale === "ko") return ko_widget_time_invalid_date(inputs)
	if (locale === "tr") return tr_widget_time_invalid_date(inputs)
	if (locale === "lv") return lv_widget_time_invalid_date(inputs)
	if (locale === "ar") return ar_widget_time_invalid_date(inputs)
	if (locale === "bs") return bs_widget_time_invalid_date(inputs)
	if (locale === "sl") return sl_widget_time_invalid_date(inputs)
	if (locale === "id") return id_widget_time_invalid_date(inputs)
	if (locale === "sv") return sv_widget_time_invalid_date(inputs)
	return "widget_time_invalid_date"
};